module.exports = __webpack_public_path__ + "img/组 1657@2x.093899f6.png";